import { render, staticRenderFns } from "./FileCollector.vue?vue&type=template&id=7c7f2fc4&"
import script from "./FileCollector.vue?vue&type=script&lang=js&"
export * from "./FileCollector.vue?vue&type=script&lang=js&"
import style0 from "./FileCollector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports